export default __webpack_public_path__ + "static/media/transferwise.5b06df7b.png";